import script from "./FilterSales.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterSales.vue?vue&type=script&setup=true&lang=ts"

import "./FilterSales.vue?vue&type=style&index=0&id=5fcd868e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fcd868e"]])

export default __exports__